import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-top1",
  "use": "icon-arrow-top1-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-top1\">\n<path d=\"M3.20357 9.80544C3.20357 9.63417 3.27208 9.46289 3.4091 9.32587L7.51968 5.21529C7.79372 4.94126 8.20477 4.94126 8.47881 5.21529L12.5894 9.32587C12.8634 9.59991 12.8634 10.011 12.5894 10.285C12.3154 10.559 11.9043 10.559 11.6303 10.285L7.99925 6.654L4.36823 10.285C4.0942 10.559 3.68314 10.559 3.4091 10.285C3.27208 10.148 3.20357 9.97672 3.20357 9.80544Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol